import {ComponentProps} from "react"
import {Divider, Paper} from "@mui/material"
import {styled} from "@mui/material/styles"

function _Panel({children, ...props}: ComponentProps<typeof Paper>) {
	return (
		<Paper {...props}>
			<DivContainer>{children}</DivContainer>
		</Paper>
	)
}

export const Panel = styled(_Panel)`
	width: 100%;

	border-radius: 0.5rem;
	border: 1px solid #f6f6f6;
	background: #fff;
	box-shadow: 0px 4px 24px 0px rgba(54, 59, 100, 0.2);
`

const DivContainer = styled("div")`
	/* <359px: Minimal padding for very small screens */
	padding: 0.75rem 1rem;

	/* 360px to 410px: Small mobile padding */
	@media (min-width: 360px) {
		padding: 1rem 1.5rem;
	}

	/* 411px to 599px: Large mobile padding */
	@media (min-width: 411px) {
		padding: 1rem 1.5rem;
	}

	/* 600px to 899px: Tablet padding */
	@media (min-width: 600px) {
		padding: 1.5rem 2rem;
	}

	/* >900px: Desktop padding - matches Figma px-10 py-8 (2.5rem horizontal, 2rem vertical) */
	@media (min-width: 900px) {
		padding: 2rem 2.5rem;
	}
`

export const PanelDivider = styled(Divider)`
	border-color: #f6f6f6;
	margin: 1rem 0;
`
